import { render, staticRenderFns } from "./ArticleAuthorModule.vue?vue&type=template&id=a375f0ee&"
import script from "./ArticleAuthorModule.ts?vue&type=script&lang=ts&"
export * from "./ArticleAuthorModule.ts?vue&type=script&lang=ts&"
import style0 from "./ArticleAuthorModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports